import { useQueries } from "@tanstack/react-query";
import { appService, type AppPlatform } from "@/lib/api/services/app";

const PLATFORMS: AppPlatform[] = ["ios", "android"]; // order matches store link display order

export type AppRating = {
  platform: AppPlatform;
  rating: number;
  review_count: number;
};

export function useAppRating() {
  const results = useQueries({
    queries: PLATFORMS.map((platform) => ({
      queryKey: ["app-rating", platform],
      queryFn: () => appService.getAppRating(platform),
      staleTime: 30 * 60 * 1000,
    })),
  });

  const ratings: AppRating[] = results
    .map((result) => result.data)
    .filter((item): item is NonNullable<typeof item> => Boolean(item))
    .map((item) => ({
      platform: item.platform,
      rating: item.rating,
      review_count: item.review_count,
    }));

  return { ratings, isLoading: results.some((result) => result.isLoading) };
}
